var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t(
        "default",
        [
          _c(
            "div",
            { staticClass: "product-detail container page-content" },
            [
              _c("div", { staticClass: "row" }, [
                _vm.isMobile
                  ? _c(
                      "div",
                      {
                        staticClass: "col-12 col-lg-7 product-detail__carousel"
                      },
                      [
                        _c("item-image-carousel", {
                          attrs: {
                            showThumbs: false,
                            "plugin-path": _vm.ceresPluginPath,
                            "image-url-accessor": "url"
                          }
                        })
                      ],
                      1
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "col-12 col-lg-7 product-detail__carousel"
                      },
                      [
                        _c("single-images", {
                          attrs: { "current-variation": _vm.currentVariation }
                        })
                      ],
                      1
                    ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-lg-5 product-detail__content" },
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "h1",
                          {
                            staticClass: "product-detail__title",
                            attrs: { "data-testing": "item-name" }
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm._f("itemName")(_vm.currentVariation)
                                ) +
                                "\n                            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("h2", { staticClass: "product-detail__sub-title" }, [
                          _vm._v(
                            "\n\n                                " +
                              _vm._s(_vm.getColor) +
                              "\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _vm._t("crossselling"),
                        _vm._v(" "),
                        _vm._t("after-price"),
                        _vm._v(" "),
                        _vm.attributes.length || Object.keys(_vm.units).length
                          ? _c(
                              "div",
                              { staticClass: "product-detail__variation" },
                              [
                                _vm.currentVariation.filter.isSalable ||
                                (!_vm.currentVariation.filter.isSalable &&
                                  _vm.currentVariation.filter
                                    .hasActiveChildren) ||
                                _vm.hasSalableVariation
                                  ? _c("variation-select")
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "product-detail__bundle" },
                          [
                            _vm.currentVariation.variation.bundleType ===
                            "bundle"
                              ? _c("item-bundle", {
                                  attrs: {
                                    "bundle-type":
                                      _vm.currentVariation.variation.bundleType,
                                    "bundle-components":
                                      _vm.currentVariation.bundleComponents
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._t("before-add-to-basket"),
                        _vm._v(" "),
                        _vm.currentVariation.item.itemType === "set"
                          ? _c(
                              "div",
                              { staticClass: "alert alert-info w-100" },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemSetInfo"
                                      )
                                    ) +
                                    "\n                            "
                                )
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticClass: "product-detail__add-to-basket row"
                              },
                              [
                                _c("add-to-basket", {
                                  staticClass: "col-12",
                                  attrs: {
                                    "variations-obj": _vm.variationsObj,
                                    "variation-id":
                                      _vm.currentVariation.variation.id,
                                    "is-salable":
                                      !!_vm.currentVariation.filter &&
                                      _vm.currentVariation.filter.isSalable,
                                    "has-children":
                                      !!_vm.currentVariation.filter &&
                                      _vm.currentVariation.filter
                                        .hasActiveChildren,
                                    "interval-quantity":
                                      _vm.currentVariation.variation
                                        .intervalOrderQuantity || 1,
                                    "minimum-quantity":
                                      _vm.currentVariation.variation
                                        .minimumOrderQuantity,
                                    "maximum-quantity":
                                      !!_vm.currentVariation.variation
                                        .maximumOrderQuantity &&
                                      _vm.currentVariation.variation
                                        .maximumOrderQuantity > 0
                                        ? _vm.currentVariation.variation
                                            .maximumOrderQuantity
                                        : null,
                                    "order-properties": _vm.currentVariation.properties.filter(
                                      function(prop) {
                                        return prop.property.isOderProperty
                                      }
                                    ),
                                    "has-order-properties":
                                      _vm.currentVariation.hasOrderProperties,
                                    "has-required-order-property":
                                      _vm.currentVariation
                                        .hasRequiredOrderProperty,
                                    "use-large-scale": false,
                                    "show-quantity": true,
                                    "item-url": _vm._f("itemURL")(
                                      _vm.currentVariation
                                    ),
                                    "is-variation-selected":
                                      _vm.isVariationSelected &&
                                      _vm.currentVariation.filter.isSalable,
                                    "has-price": _vm._f("hasItemDefaultPrice")(
                                      _vm.currentVariation
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-12 product-detail__vat-information"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "FLGNTLT::Template.vatInformation"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                        _vm._v(" "),
                        _vm._t("after-add-to-basket"),
                        _vm._v(" "),
                        _vm._t("additional-content-after-add-to-basket"),
                        _vm._v(" "),
                        _vm.currentVariation.texts.description !== ""
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "single-details__wrapper single-details__wrapper--1"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "single-details__headline" },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$translate(
                                            "FLGNTLT::Template.details"
                                          )
                                        ) +
                                        "\n                                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "single-details__text",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.currentVariation.texts.description
                                    )
                                  }
                                })
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentVariation.texts.technicalData !== ""
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "single-details__wrapper single-details__wrapper--2"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "single-details__headline" },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$translate(
                                            "FLGNTLT::Template.sizeinfo"
                                          )
                                        ) +
                                        "\n                                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "single-details__text",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.currentVariation.texts.technicalData
                                    )
                                  }
                                })
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.sizechartImg !== ""
                          ? _c(
                              "div",
                              { staticClass: "size-chart__wrapper" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "size-chart__headline",
                                    attrs: {
                                      "data-toggle": "modal",
                                      href: "#sizechart"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$translate(
                                            "FLGNTLT::Template.sizechart"
                                          )
                                        ) +
                                        "\n                                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("size-chart")
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _vm._t("dropzone1"),
              _vm._v(" "),
              _vm._t("item-list-container"),
              _vm._v(" "),
              _vm._t("feedback-container")
            ],
            2
          )
        ],
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField
        }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }